const GlobalHttpAbortController = new AbortController();

export { GlobalHttpAbortController };
